import { commentsData } from '@/mocks/homeData';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-16 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            剧迷热评
          </h2>
          <p className="mt-2 text-sm text-foreground-500">
            听听追剧同好们怎么说
          </p>
        </div>

        <div className="space-y-5">
          {commentsData.map((comment, index) => (
            <div
              key={index}
              className="p-5 md:p-6 bg-background-100 rounded-lg"
            >
              <div className="flex items-start gap-4">
                <div className="w-11 h-11 rounded-full overflow-hidden flex-shrink-0">
                  <img
                    src={comment.avatar}
                    alt={comment.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 flex-wrap">
                    <span className="font-heading text-sm font-semibold text-foreground-900 whitespace-nowrap">
                      {comment.name}
                    </span>
                    <span className="text-xs text-foreground-400 whitespace-nowrap">
                      {comment.time}
                    </span>
                  </div>
                  <p className="mt-2 text-sm text-foreground-600 leading-relaxed">
                    {comment.content}
                  </p>
                  <div className="mt-3 flex items-center gap-4">
                    <span className="inline-flex items-center gap-1 text-xs text-foreground-400 cursor-pointer hover:text-primary-500 transition-colors">
                      <i className="ri-thumb-up-line"></i>
                      有用
                    </span>
                    <span className="inline-flex items-center gap-1 text-xs text-foreground-400 cursor-pointer hover:text-primary-500 transition-colors">
                      <i className="ri-chat-1-line"></i>
                      回复
                    </span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}